/**
 * Cape Verdean escudo.
 */
export var CVE = {
  code: 'CVE',
  base: 10,
  exponent: 2
};